import styled from 'styled-components';

export const Container = styled.div``;

export const GeneralInfoContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const GeneralInfoContentItensContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 1rem;

  & .vehicle-description {
    display: flex;
    flex-direction: column;
  }
`;

export const GeneralInfoContentItem = styled.div`
  width: 12.25rem;
  word-break: break-all;
`;
